import { render, staticRenderFns } from "./TenantDashboard.vue?vue&type=template&id=1753c34b&scoped=true&"
import script from "./TenantDashboard.vue?vue&type=script&lang=js&"
export * from "./TenantDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TenantDashboard.vue?vue&type=style&index=0&id=1753c34b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1753c34b",
  null
  
)

export default component.exports